<template lang="pug">
    .wrapper
        .titulo(v-if="titulo") {{ titulo }}
        .opcoes(ref="opcoes")
            .opcao(v-for="opcao in opcoes" :key="opcao.id" :class="opcao.id === opcaoSelecionada ? 'selecionada' : ''")
                label.opcao-info(:for="opcao.id")
                    p.nome {{ opcao[opcaoRef] }}
                    input(
                    type="radio"
                    :name="nomeGrupo"
                    :id="opcao.id"
                    :value="opcao.id"
                    style="display: none"
                    v-model="opcaoSelecionada"
                    )
                    p(v-if="opcao.locais") {{ opcao.locais ? `${opcao.locais.length} ${opcao.locais.length <= 1 ? $t('comum.seletores.radioSelect.localAssociado') : $t('comum.seletores.radioSelect.locaisAssociados')}` : '' }}
</template>
<script>
export default {
  name: 'RadioSelect',
  props: {
    titulo: {type: String, required: false, default: ''},
    nomeGrupo: {type: String, required: true},
    opcoes: {type: Array, required: true},
    opcaoRef: {type: String, required: true},
    faltaItems: {type: Boolean, required: false, default: false}
  },
  data () {
    return {
      opcaoSelecionada: null
    }
  },
  watch: {
    opcaoSelecionada (currentValue) {
      this.$emit('opcaoSelecionada', currentValue)
    }
  }
}
</script>
<style scoped>
.wrapper {
    width: 100%;
}
.opcoes {
    width: inherit;
    border: 1px solid #ccc;
    background-color: #fff;
    max-height: 220px;
    overflow-y: scroll;
}
.opcao {
    width: inherit;
    min-height: 60px;
    padding: 0 0.375rem;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.opcao:hover {
    background-color: var(--color-success-hover);
    color: var(--color-default-hover)
}
.opcao.selecionada {
    background-color: var(--color-success-hover);
    color: var(--color-default-hover)
}
.opcao-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    min-height: inherit;
    cursor: pointer;
    flex: 1;
    text-align: left;
}
.opcao-info .nome {
    font-weight: 700;
}
</style>
